import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Expertise of Our App Developers in Diverse Tech Stack
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Having a diverse team of app developers in KSA, we get the edge to
              facilitate our clients with multiple technologies that suit their
              project requirements. Here’s the list of our tech stack:
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Front-End">
              <ul>
                <li>Angular</li>
                <li>Vue.js</li>
                <li>React.js</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Back-End">
              <ul>
                <li>Ruby on Rails</li>
                <li>Laravel</li>
                <li>React.js</li>
                <li>PHP</li>
                <li>NET</li>
                <li>Golang</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Mobile">
              <ul>
                <li>Android</li>
                <li>iOS</li>
                <li>React Native</li>
                <li>Flutter</li>
                <li>Ionic</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Server">
              <ul>
                <li>AWS</li>
                <li>Digital Ocean</li>
                <li>Heroku</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Database">
              <ul>
                <li>MongoDB</li>
                <li>PostgreSQL</li>
                <li>MySQL</li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Version Control">
              <ul>
                <li>Salesforce</li>
                <li>MS Dynamics 365</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
